import React from 'react';
import { PortraitsWithTextType } from '../../../../../../../types/portraitsWithTextType';
import { PortraitsWithTextBlock } from '../../../../SectionBlocks/blocks/PortraitsWithTextBlock';
import { ArticleBlockContentGridCol } from './ArticleBlockContentGridCol';
import { BlockContentContext } from '../../../BlockContent.utils';

interface PortraitsWithTextProps {
  value: PortraitsWithTextType;
}

export const PortraitsWithTextSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: PortraitsWithTextProps) => (
      <ArticleBlockContentGridCol className="portraitsWithText">
        <PortraitsWithTextBlock block={value} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: PortraitsWithTextProps) => <PortraitsWithTextBlock block={value} />;
};
